import moment from 'moment'

export const packaging = {
    id: '',
    name: '',
    updatedAt : moment().format('YYYY-MM-DD'),
}